(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wraptor-category-browser"] && !Shopify.designMode) return;
  try {
    
function sortWraptorCategories(root){root.querySelectorAll('.wr-category__grid,.wr-category__card ul').forEach(list=>[...list.children].sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order)).forEach(item=>list.append(item)));}
sortWraptorCategories(document);
document.addEventListener('shopify:section:load',event=>sortWraptorCategories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wraptor-category-products"]) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid=root.querySelector('[data-products]'),status=root.querySelector('[data-status]'),links=[...root.querySelectorAll('[data-kind]')];
    let loaded=false,failed=false;
    for(const nav of root.querySelectorAll('nav'))[...nav.children].sort((a,b)=>Number(a.dataset.order||9999)-Number(b.dataset.order||9999)).forEach(a=>nav.append(a));
    function filter(){
      const params=new URLSearchParams(location.hash.slice(1)),kind=params.has('subcategory')?'subcategory':'category',handle=params.get(kind),selected=links.find(a=>a.dataset.kind===kind&&a.dataset.handle===handle);
      root.querySelector('[data-title]').textContent=selected?selected.dataset.name:root.querySelector('nav').getAttribute('aria-label');
      root.querySelector('[data-description]').textContent=selected?.dataset.description||'';
      const parent=kind==='subcategory'?selected?.dataset.parent:handle;
      links.forEach(a=>{a.setAttribute('aria-current',String(a===selected));if(a.dataset.kind==='subcategory')a.hidden=a.dataset.parent!==parent;});
      root.querySelector('.wr-catalog__subnav').hidden=!parent;
      let count=0;
      for(const item of grid.children){const values=(kind==='subcategory'?item.dataset.subcategories:item.dataset.categories)||'';item.hidden=!!selected&&!values.split(/\s+/).includes(handle);if(!item.hidden)count++;}
      status.textContent=failed?root.dataset.error:!loaded?root.dataset.loading:count?count+' '+root.dataset.count:root.dataset.empty;
    }
    window.addEventListener('hashchange',filter);filter();
    async function load(){
      let next=root.querySelector('[data-next]')?.getAttribute('href');
      const seen=new Set([...grid.children].map(x=>x.dataset.productId)),pages=new Set();
      try{
        while(next){
          const url=new URL(next,location.origin);url.searchParams.set('view','wraptor-category');url.searchParams.set('section_id',root.dataset.section);
          if(pages.has(url.href))throw Error('Repeated page');pages.add(url.href);
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('Page unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');const source=doc.querySelector('[data-wr-catalog]');if(!source)throw Error('Missing product data');
          source.querySelectorAll('[data-product-id]').forEach(item=>{if(!seen.has(item.dataset.productId)){seen.add(item.dataset.productId);grid.append(document.importNode(item,true));}});
          next=source.querySelector('[data-next]')?.getAttribute('href');filter();
        }
        loaded=true;
      }catch(e){failed=true;}filter();
    }
    load();
  }
  document.querySelectorAll('[data-wr-catalog]').forEach(init);
  document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-wr-catalog]')));
})();

  } catch(e) { console.error(e); }
})();
})();
